// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-04-09T08:58:00+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191831
//    Project:        234
//    Environment:    493 - master
//    MD5:            b235f780328c32cb21447f206d6adb4b
//    Signature:      eyJpdiI6IlhIeXM1MzZmY2dJbnlzbUpYTnZWbXc9PSIsInZhbHVlIjoiXC9pZENFRUhMakp0SnQxUk81N05HcllcLzhiMzlsYVl5SDYwR1RhamZcL2tNb21na1FRNWduV0pDbDJBbDV4QmZRajQ0NllybUZIeUdJdTVOSlwvQjVGdktkZFhkV1dFRUl0T3lsVlwvallmXC96XC94aVc3Y3UxaDloazB6OVhYQmNZWVBWSG5lcWpxMmlJeEJIZ2Z4akFsVmxPb05IZkpqXC9NOXdWblBpa01YNjlnUkQrY1hiTjBOT0NiWVB6QWNrVjN4SGppQnQ5RExXZFFyZXBMU052czc4SWZhWlwvMFdOeUh3eHc4SWFka1RnS2hTclNySlJTU2NocmFCMm1CMzhIZU5hWkNLajVqQU1YaUZiWmQwQ2NDRUNJdW5vTGpybkd6Z2tMekt6dVNuR1I2b1hqOUhKZDQ3STFWRzhmNEEydGUzZTlhNXUwV2VXRURYSFlieHJuTitFMVdKc2k2Yk5iNFpRMmlZZXhZcnJoT0poV1hnTmZ0TThhQWhTQVBMMkFBMEI0OHhXc2hmVjlvRjdxSG5aYk54TExiZz09IiwibWFjIjoiMWIzODExMDczMDM4MDdkZGNjMzkyZTkxNDJiNjlhZjE5OWU1NTcwNmUzNGZiNzc3NzBkYTZkMWE4OGVhYjBkMiJ9
/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================= Breeze ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';
var klevu_productsToShowInSlimLayout = 12;

klevu.beforeActivation("quick", function(data, scope){
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickProductBlockTitleHeaderCustom, 'klevuQuickProductBlockTitleHeader', true);
        box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickRecentViewedProductBlockCustom, 'klevuQuickRecentViewedProductBlock', true);
        box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);
    });
});

klevu.afterTemplateRender('quick', function (data, scope) {
    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.kuQuickSearchAutoCompleteLayout .klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);
});
/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickProductBlockTitleHeaderCustom = `
  <div class="klevuSuggestionHeading">
    <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
  </div>
  <div class="klevuProductsViewAll">
    <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
    <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View All")%></a>
  </div>
`;

var klevuQuickProductBlockCustom = `
<%
    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
    var tags = dataLocal.tags.split(',');
%>
<li ku-product-block class="klevuProduct klevuProductClick kuTrackRecentView" data-id="<%=dataLocal.id%>">
  <a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView product-card">
    <div class="product-card__image-wrapper">
      <img class="product-card__image" src="<%= dataLocal.image.replace('_medium', '_700x900') %>" origin="<%= dataLocal.image %>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=dataLocal.name %>" />
      <div class="product-card-badges">
        <% if (!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)) { %>
          <% var percentDecrease = Math.floor(((kuPrice - kuSalePrice) / kuPrice) * 100) %>
          <span class="product-card-badges__badge product-card-badges__badge--sale">-<%= percentDecrease %>%</span>
        <% } %>
      </div>
      <div class="product-card-badges product-card-badges--high">
        <% if(tags.includes('r1-3-for-2-socks')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #7fca95;">
            3 for 2
          </span>
        <% } else if (tags.includes('r1-socks-5-for-1295')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #F3A0BE;">
            5 for £12.95
          </span>
        <% } else if (tags.includes('r1-mix-match-2-for-45')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
            <img src="//www.routeone.co.uk/cdn/shop/files/2-For-45-1080x1080px_small.png?v=1746714642" class="product-card-badges__badge__icon" style="width: 34px;">
          </span>
        <% } else if (tags.includes('r1-mix-match-2-for-60')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-60 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
            <img src="//www.routeone.co.uk/cdn/shop/files/2-For-60-1080x1080px_small.png?v=1711016042" class="product-card-badges__badge__icon" style="width: 34px;">
          </span>
        <% } else if (tags.includes('r1-mix-match-2-for-70')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-70 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
            <img src="//www.routeone.co.uk/cdn/shop/files/2-For-70-1080x1080px_small.png?v=1711016075" class="product-card-badges__badge__icon" style="width: 34px;">
          </span>
        <% } else if (tags.includes('r1-mix-match-2-for-80')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-80 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
            <img src="//www.routeone.co.uk/cdn/shop/files/2-For-80-1080x1080px_small.png?v=1711016117" class="product-card-badges__badge__icon" style="width: 34px;">
          </span>
        <% } else if (tags.includes('r1-mix-match-2-for-90')) { %>
          <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-90 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
            <img src="//www.routeone.co.uk/cdn/shop/files/2-For-90-1080x1080px_small.png?v=1711016142" class="product-card-badges__badge__icon" style="width: 34px;">
          </span>
        <% } %>
      </div>
    </div>
    <div class="product-card__meta">
      <div class="product-card__title" title="<%= dataLocal.name %>"><%= dataLocal.name %></div>
      <div class="product-card__meta-row">
        <div class="product-card__price body-sm product-price">
          <% if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
            <span class="product-card__price body-sm--sale product-price__money--sale">
              <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
            </span>
            <span class="money strikethrough">
              <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
            </span>
          <% } else if(!Number.isNaN(kuSalePrice)) { %>
            <span class="product-card__price">
              <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
            </span>
          <% } else if(!Number.isNaN(kuPrice)) { %>
            <span class="product-card__price">
              <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
            </span>
          <% } %>
        </div>
      </div>
    </div>
  </a>
</li>
`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
   var hasResults = true;
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
        hasResults = false;
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header class="kuQuickSearchContainer" ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <% if(!(data.query.productList && data.query.productList.result.length > 0)) { %>
                          <%= helper.render('kuTemplatePopularSearches',scope) %>
                        <% } %>
                    </div>
                </section>
            </header>
            <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                <div class="klevuSuggestionsProductsBlock">
                  <% if(data.query.productList && !!data.query.productList.meta.searchedTerm && !data.query.productList.result.length) { %>
                    <div class="klevu__no-results-message">"<%= data.query.productList.meta.searchedTerm %>" returned 0 results</div>
                  <% } %>
                  <% if(data.query.productList && data.query.productList.result.length > 0) { %>
                      <%= helper.render('klevuQuickProducts',scope) %>
                  <% } else { %>
                      <%= helper.render('klevuTrendingProducts',scope) %>
                  <% } %>  
                </div>
            </section>
            <footer>
              <%=helper.render('kuTemplateRecentSearches',scope) %>
              <%=helper.render('klevuQuickPageSuggestions',scope) %>
            </footer>
        </div>
    </div>
</div>`;

var klevuQuickTrendingProductBlockCustom = `
<%
    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
    var tags = dataLocal.tags.split(',');
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView product-card">
  <div class="product-card__image-wrapper">
    <img class="product-card__image" src="<%= dataLocal.image.replace('_medium', '_700x900') %>" origin="<%= dataLocal.image %>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=dataLocal.name %>" />
    <div class="product-card-badges">
      <% if (!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)) { %>
        <% var percentDecrease = Math.floor(((kuPrice - kuSalePrice) / kuPrice) * 100) %>
        <span class="product-card-badges__badge product-card-badges__badge--sale">-<%= percentDecrease %>%</span>
      <% } %>
    </div>
    <div class="product-card-badges product-card-badges--high">
      <% if(tags.includes('r1-3-for-2-socks')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #7fca95;">
          3 for 2
        </span>
      <% } else if (tags.includes('r1-socks-5-for-1295')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #F3A0BE;">
          5 for £12.95
        </span>
      <% } else if (tags.includes('r1-mix-match-2-for-45')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
          <img src="//www.routeone.co.uk/cdn/shop/files/2-For-45-1080x1080px_small.png?v=1746714642" class="product-card-badges__badge__icon" style="width: 34px;">
        </span>
      <% } else if (tags.includes('r1-mix-match-2-for-60')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-60 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
          <img src="//www.routeone.co.uk/cdn/shop/files/2-For-60-1080x1080px_small.png?v=1711016042" class="product-card-badges__badge__icon" style="width: 34px;">
        </span>
      <% } else if (tags.includes('r1-mix-match-2-for-70')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-70 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
          <img src="//www.routeone.co.uk/cdn/shop/files/2-For-70-1080x1080px_small.png?v=1711016075" class="product-card-badges__badge__icon" style="width: 34px;">
        </span>
      <% } else if (tags.includes('r1-mix-match-2-for-80')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-80 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
          <img src="//www.routeone.co.uk/cdn/shop/files/2-For-80-1080x1080px_small.png?v=1711016117" class="product-card-badges__badge__icon" style="width: 34px;">
        </span>
      <% } else if (tags.includes('r1-mix-match-2-for-90')) { %>
        <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-90 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
          <img src="//www.routeone.co.uk/cdn/shop/files/2-For-90-1080x1080px_small.png?v=1711016142" class="product-card-badges__badge__icon" style="width: 34px;">
        </span>
      <% } %>
    </div>
  </div>
  <div class="product-card__meta">
    <div class="product-card__title" title="<%= dataLocal.name %>"><%= dataLocal.name %></div>
    <div class="product-card__meta-row">
      <div class="product-card__price body-sm product-price">
        <% if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
          <span class="product-card__price body-sm--sale product-price__money--sale">
            <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
          </span>
          <span class="money strikethrough">
            <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
          </span>
        <% } else if(!Number.isNaN(kuSalePrice)) { %>
          <span class="product-card__price">
            <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
          </span>
        <% } else if(!Number.isNaN(kuPrice)) { %>
          <span class="product-card__price">
            <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
          </span>
        <% } %>
      </div>
    </div>
  </div>
</a>`;

var klevuQuickRecentViewedProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
    <div class="klevuProductItemTop">
        <div class="klevuQuickImgWrap">
            <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
            <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
        </div>
    </div>
    <div class="klevuProductItemBottom">
        <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
            <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
        <div class="klevuQuickProductDescBlock">
            <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
            <div class="klevuQuickProductDesc">
                <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div> <div class="klevuQuickProductPrice">
                <%
                    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                %>
                <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                    <div class="klevuQuickSalePrice kuStartPrice">
                        <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                    </div>
                <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                    <span class="klevuQuickOrigPrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                    <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                        <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                    </span>
                <% } else if(!Number.isNaN(kuSalePrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                    </span>
                <% } else if(!Number.isNaN(kuPrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                <% } %>
            </div>
            </div>                
        </div>
    </div>        
</a>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
<section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
    <div ku-block data-block-id="ku_quick_left_facets"></div>
    <div ku-block data-block-id="ku_quick_left_call_outs">
        <%=helper.render('kuTemplatePopularSearches',scope) %>
        <%=helper.render('kuTemplateRecentSearches',scope) %>
    </div>
    <% if (window.innerWidth >= 768) { %>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    <% } %>
</section>
<section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
    <header ku-block data-block-id="ku_quick_result_header"></header>
    <div ku-block data-block-id="ku_quick_result_items"></div>
                
    <div ku-block data-block-id="ku_quick_other_items">
        <%=helper.render('klevuTrendingProducts',scope) %>
        <% if (window.innerWidth < 768) { %>
            <div ku-block data-block-id="ku_quick_left_banner"></div>
        <% } %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
    </div>

    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
</section>
<section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
    <div ku-block data-block-id="ku_quick_right_facets"></div>
    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
    <div ku-block data-block-id="ku_quick_right_banner"></div>
</section>
</div>`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ======================= Harbor ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu.beforeActivation("landing", function (data, scope) {
  scope.kScope.template.setTemplate(KlevuLandingTemplatePaginationFancy, 'pagination', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, 'productBlock', true);
  scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);

  // Remove scrollToTop
  scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

  (function (klevu) {
    klevu.extend(true, klevu.search.modules, {
      addParamsToURL: {
        base: {
          addURLtoHistory: function (data, scope, queryId) {
            // Global stuff
            if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
              console.error("This browser does not have the support of window.history or window.history.pushState");
              return;
            }

            var searchPath = new URLSearchParams(window.location.search);
            var currentSearchPath;
            var previousSearchPath = searchPath.toString();

            // this is in case we're running our code where we dont have context.activeQueryId
            var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
            if (queryId && queryId.length) {
              activeQueryId = queryId;
            }

            // Check if there any filter selected
            let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
            let isThereFiltersSelected = false;
            // Check if applyFilters is an object (but not an array), and not empty
            if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
              isThereFiltersSelected = true;
            }

            // PAGINATION TO URL
            var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
            var paginationQueryParam = "Page";
            var currentPage = 0;

            if (hasPaginationEnabled) {
              var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
              if (activeQueryMeta) {
                var productListLimit = activeQueryMeta.noOfResults;
                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
              }

              if (currentPage === 0 || currentPage === 1) {
                searchPath.delete(paginationQueryParam);
              } else {
                searchPath.set(paginationQueryParam, currentPage);
              }

              currentSearchPath = searchPath.toString();
            };

            // FILTERS TO URL
            var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
            var filterValuesQueryParam = "";

            if (activeQueryFilters) {
              klevu.each(activeQueryFilters, function (key, filter) {
                var selectedFilterKeyString = "";
                var filterOptions = filter.options;
                var selectedValues = "";

                if (filterOptions && filterOptions.length) {
                  klevu.each(filterOptions, function (key, option) {
                    if (option.selected === true) {
                      if (selectedValues.length) {
                        selectedValues += ",";
                      }
                      selectedValues += option.value;
                    }
                  });
                } else if (filter.type === "SLIDER") {
                  var startValue = filter.start;
                  var endValue = filter.end;
                  var minValue = filter.min;
                  var maxValue = filter.max;
                  if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                    if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                      // just skipping
                    } else {
                      selectedValues = startValue + "-" + endValue;
                    }
                  }
                }

                if (selectedValues.length) {
                  // selectedFilterKeyString += filter.key + ":" + selectedValues;
                  selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                }

                if (selectedFilterKeyString.length) {
                  if (filterValuesQueryParam.length) {
                    filterValuesQueryParam += ";";
                  }
                  filterValuesQueryParam += selectedFilterKeyString;
                }
              });
            }

            if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
              searchPath.set("Filters", filterValuesQueryParam);
            } else {
              searchPath.delete("Filters");
            }

            currentSearchPath = searchPath.toString();

            // ==============================
            // Final URL change
            if (previousSearchPath !== currentSearchPath) {
              var historyState = { page: currentPage, filters: currentSearchPath };
              window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
            }
          },

          restoreSearchParamsOnPageLoad: function (data, scope) {
            var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
            if (hasAlreadyTriggered) return;

            var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

            var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
            var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

            var matchedQueryParamId = "";
            var matchedQueryParamValue = "";
            var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

            if (recordQueries && recordQueries.length) {
              klevu.each(recordQueries, function (key, recordQuery) {
                if (recordQuery.id) {
                  if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                    matchedQueryParamId = recordQuery.id;
                    matchedQueryParamValue = paginationFromURL || filtersFromURL;
                  }
                }
              });
            }

            klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

            matchedQueryParamId = activeQueryId || "productList";

            if (matchedQueryParamId.length && matchedQueryParamValue.length) {
              activeQueryId = matchedQueryParamId;
              var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
              if (storage.tabs) {
                storage.tabs.setStorage("local");
                storage.tabs.mergeFromGlobal();
                storage.tabs.addElement("active", activeQueryId);
                storage.tabs.mergeToGlobal();
              }
            }

            if (paginationFromURL && paginationFromURL > 1) {
              if (recordQueries && recordQueries.length) {
                klevu.each(recordQueries, function (key, recordQuery) {
                  if (recordQuery.id === activeQueryId) {
                    var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                    limit = Number(limit);
                    if (limit > 0) {
                      var expectedOffset = (paginationFromURL - 1) * limit;
                      klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                    }
                  }
                });
              }
            }

            // FILTERS
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(";");
              if (facets) {
                klevu.each(facets, function (key, facet) {
                  var splitFacet = facet.split(":");
                  if (splitFacet.length) {
                    var facetKey = decodeURIComponent(splitFacet[0]);
                    var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                    var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                    if (applyFilters && applyFilters.length) { // if there're some filters
                      var isExistingKey = false;
                      klevu.each(applyFilters, function (key, applyFilter) {
                        if (applyFilter.key === facetKey) {
                          isExistingKey = true;
                          klevu.each(facetValues, function (key, facetValue) {
                            var isFilterOptionMatched = false;
                            klevu.each(applyFilter.values, function (key, value) {
                              if (facetValue === value) {
                                isFilterOptionMatched = true;
                              }
                            });
                            if (!isFilterOptionMatched) {
                              applyFilter.values.push(facetValue);
                            }
                          });
                        }
                      });
                      if (!isExistingKey) {
                        applyFilters.push({ key: facetKey, values: facetValues });
                      }
                    } else {
                      klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                    }

                  }
                });
              }
            }
          },

          updatePayloadOnPopState: function (data, scope, activeQueryId) {
            // SET PAGINATION PAYLOAD
            var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
            paginationFromURL = Number(paginationFromURL);
            var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
            limit = Number(limit);
            if (limit > 0) {
              var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
              klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
              // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
            }

            // SET FILTER PAYLOAD
            var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(";");
              // loop through all facets to get its values
              let facetKey = '';
              let facetValues = [];
              let facetsArray = [];

              klevu.each(facets, function (key, facet) {
                var splitFacet = facet.split(":");
                if (splitFacet.length) {
                  facetKey = decodeURIComponent(splitFacet[0]);
                  facetValues = decodeURIComponent(splitFacet[1]).split(",");
                  facetsArray.push({ key: facetKey, values: facetValues });
                }
              });
              // set the payload with correct filters:
              klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
            } else { // reset filters if Back button pressed, and there's no filters
              klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
            }
          }
        },
        build: true
      },
      smoothScrollToProductListingTop: function () {
        let customOffset = 180;
        const selectorsToTriggerScrollToTop = {
          pagination: '.kuPagination a',
          filterOptions: '.klevuFilterOption',
          sliderFilter: '.klevuSliderFilter',
          sortRadios: '.kuSortRadio',
          // Add more selectors here as needed
        }
        function _smoothScrollToKlevuTop() {
          setTimeout(function () {
              var target = document.getElementsByClassName('klevuMeta')[0];
  
              if (target) {
                  var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
  
                  window.scrollTo({
                      top: topPosition - customOffset,
                      behavior: 'smooth'
                  });
              }
          }, 100);
        }
        Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
          document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
        });
      },
      keepFacetsWithSelectedOptionsOpened: function (data, scope) {
        const selectors = {
            kuFilterBox: '.kuFilterBox',
            kuSelected: '.kuSelected',
            kuFilterNames: '.kuFilterNames',
            kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
            kuFilterHead: '.kuFilterHead',
            kuFilterHeadExpand: '.kuFilterHead.kuExpand',
            kuExpand: '.kuExpand',
            kuCollapse: '.kuCollapse',
            nouiElement: '.noUi-origin',
            priceFacetBlock: '[data-filter="klevu_price"]',
            kuFilterShowAll: '.kuFilterShowAll',
            kuFilterCollapse: '.kuFilterCollapse',
        };

        /** Collapse Filters by default */
        (function collapseAllFilters() {
            // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
            const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
            kuFilterHeadElements.forEach(element => {
                element.classList.add(selectors.kuExpand.substring(1));
                element.classList.remove(selectors.kuCollapse.substring(1));
            });

            // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
            const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
            kuFilterNamesElements.forEach(element => {
                element.classList.add(selectors.kuFilterCollapse.substring(1));
                element.classList.remove(selectors.kuFilterShowAll.substring(1));
            });
        }());


        // Regular checkbox-facets
        // Check if the required elements exist
        const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
        if (kuSelectedElements.length > 0) {
            kuSelectedElements.forEach(selectedElement => {
                // Find the parent element with the class kuFilterBox
                const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);

                // Look for the child with the class kuFilterHead.kuExpand
                const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                // Rotate icon in the title 
                if (filterHeadChild) {
                    filterHeadChild.classList.remove('kuExpand');
                    filterHeadChild.classList.add('kuCollapse');
                }

                // Find the parent element with the class kuFilterNames.kuFilterCollapse
                const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);

                // Show options
                if (filterNamesParent) {
                    filterNamesParent.classList.remove('kuFilterCollapse');
                    filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                }
            });
        }

            // Price slider facet
            var isThereAnyAppliedFacets = klevu.getObjectPath(
                scope.kScope.data,
                "localOverrides.query." +
                scope.kScope.data.context.activeQueryId +
                ".filters.applyFilters.filters"
            );
            const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
            if (isPriceFacetApplied) {
            // Find the parent element with the class kuFilterNames.kuFilterCollapse
            const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);

            if (nouiElement) {
                const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);

                // Show options
                if (filterNamesParent) {
                    filterNamesParent.classList.remove('kuFilterCollapse');
                    filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                }

                // Find the parent element with the class kuFilterBox
                const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);

                // Look for the child with the class kuFilterHead.kuExpand
                const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                // Rotate icon in the title
                if (filterHeadChild) {
                    filterHeadChild.classList.remove('kuExpand');
                    filterHeadChild.classList.add('kuCollapse');
                }
            }
        }

        // Function-helper to find the parent element with a specified class
        function findParentWithClass(element, className) {
            let parent = element.parentElement;
            while (parent) {
                if (parent.matches(className)) {
                    return parent;
                }
                parent = parent.parentElement;
            }
            return null; // No matching parent found
        }
      },
    });
  })(klevu);
  
});

klevu.afterTemplateRender("landing", function (data, scope) {
  klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
  klevu.search.modules.smoothScrollToProductListingTop(data, scope);
  klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);

});

klevu.afterTemplateRender("landing", function (data, scope) {
  var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");
  klevu.each(klevu.dom.find("#kuFilterOpener", target), function (key, value) {
    klevu.event.attach(value, "click", function (event) {
      document.getElementsByTagName("body")[0].classList.toggle("filter_opened");
    });
  });
});

klevu.modifyRequest("landing", function (data, scope) {
  // Restore Search Params On Page Load
  klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

  // set the global scope
  window.klevuCurrentScope = scope.kScope;

  klevu.each(data.request.current.recordQueries, function (key, query) {
    // No results limit
    const queryID = klevu.getObjectPath(query, "id");
    if (queryID === 'noResultsFoundPopularProductList') {
      klevu.setObjectPath(query, "settings.limit", 8);
    }
    // No results limit END
  });
});

window.onpopstate = function (event) {
  try {
    // passing activeQueryId because it's lost once we reset the data below
    var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
    // code to get ready to reset all the data
    var data = window.klevuCurrentScope.element.kObject.getScope().data;
    var scope = window.klevuCurrentScope.element;
    scope.kScope.data = scope.kObject.resetData(scope.kElem);
    scope.kScope.data.context.keyCode = 0;
    scope.kScope.data.context.eventObject = event;
    scope.kScope.data.context.event = "keyUp";
    scope.kScope.data.context.preventDefault = false;

    // Get payload for Filters & Pagination
    klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

    // Fire request, re-render results
    klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
  } catch (error) {
    console.log(error)
  }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var KlevuLandingTemplatePaginationFancy = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var productListLimit = data.query[dataLocal].meta.noOfResults;
        var productListTotal = data.query[dataLocal].meta.totalResultsFound - 1;
        var totalPages;
        if (productListTotal === 0) {
            totalPages = 1;
        } else {
            totalPages = Math.ceil(productListTotal / productListLimit);
        }
        var kuCurrentPageNumber = Math.ceil(data.query[dataLocal].meta.offset/productListLimit)+1;
        var options = '';
        var optionsLabel = '';
        for (var i = 1; i <= totalPages; i++) {
            if (i === kuCurrentPageNumber) {
                options += '<div class="kuDropOption kuPagination" role="option"><a href="javascript:void(0)" class="kuCurrent kuFlexCenter">' + helper.translate("Page") + i + '</a></div>';
                optionsLabel = 'Page ' + i + ' of ' + totalPages;
            } else {
                options += '<div class="kuDropOption kuPagination" role="option"><a target="_self" href="javascript:void(0)" class="klevuPaginate kuFlexCenter" data-offset="' + (productListLimit)*(i-1) + '">' + helper.translate("Page") + i + '</a></div>';
            }
        };
    %>

    <div class="kuPagination kuFlexCenter">

        <!-- // Code for left arrow cirlce -->
        <% if(kuCurrentPageNumber !== 1) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate"
                    data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>"
            >
                <button aria-label="Previous" tabindex="-1" class="kuFlexCenter button button--primary button--small">
                  <svg class="kuPaginationIcon" aria-label="Scroll Previous" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(90deg);" width="15" height="8" viewBox="0 0 15 8"><defs><style>.cls-1{fill:none;stroke:#0d2f47;stroke-linecap:round;stroke-linejoin:round;}</style></defs><polyline class="cls-1" points="14.5 0.5 7.5 7.5 0.5 0.5"/></svg> 
                  <span>Previous</span>
                </button>
            </a>
        <% } %>

        <div class="kuDropdown kuDropPaginations" role="listbox"> 
        <div class="kuDropdownLabel"><%=optionsLabel%></div> 
            <div class="kuDropdownOptions"> 
                <%=options%>
            </div> 
        </div>

        <!-- // Code for Right arrow cirlce -->
        <% if(kuCurrentPageNumber !== totalPages) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate"
                    data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>"
            >
                <button aria-label="Next" tabindex="-1" class="kuFlexCenter button button--primary button--small">
                  <span>Next</span>
                  <svg class="kuPaginationIcon" aria-label="Scroll Next" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg);" width="15" height="8" viewBox="0 0 15 8"><defs><style>.cls-1{fill:none;stroke:#0d2f47;stroke-linecap:round;stroke-linejoin:round;}</style></defs><polyline class="cls-1" points="14.5 0.5 7.5 7.5 0.5 0.5"/></svg>
                </button>
            </a>
        <% } %>
    </div>
<% } %>`;

var klevuLandingTemplateProductBlockCustom = `
  <%
    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
    var tags = dataLocal.tags.split(',');
  %>
  <li ku-product-block class="klevuProduct klevuProductClick kuTrackRecentView" data-id="<%=dataLocal.id%>">
    <a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView product-card">
      <div class="product-card__image-wrapper">
        <img class="product-card__image" src="<%= dataLocal.image.replace('_medium', '_700x900') %>" origin="<%= dataLocal.image %>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=dataLocal.name %>" />
        <div class="product-card-badges">
          <% if (!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)) { %>
            <% var percentDecrease = Math.floor(((kuPrice - kuSalePrice) / kuPrice) * 100) %>
            <span class="product-card-badges__badge product-card-badges__badge--sale">-<%= percentDecrease %>%</span>
          <% } %>
        </div>
        <div class="product-card-badges product-card-badges--high">
          <% if(tags.includes('r1-3-for-2-socks')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #7fca95;">
              3 for 2
            </span>
          <% } else if (tags.includes('r1-socks-5-for-1295')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--light-text" style="background-color: #F3A0BE;">
              5 for £12.95
            </span>
          <% } else if (tags.includes('r1-mix-match-2-for-45')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-45 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
              <img src="//www.routeone.co.uk/cdn/shop/files/2-For-45-1080x1080px_small.png?v=1746714642" class="product-card-badges__badge__icon" style="width: 34px;">
            </span>
          <% } else if (tags.includes('r1-mix-match-2-for-60')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-60 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
              <img src="//www.routeone.co.uk/cdn/shop/files/2-For-60-1080x1080px_small.png?v=1711016042" class="product-card-badges__badge__icon" style="width: 34px;">
            </span>
          <% } else if (tags.includes('r1-mix-match-2-for-70')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-70 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
              <img src="//www.routeone.co.uk/cdn/shop/files/2-For-70-1080x1080px_small.png?v=1711016075" class="product-card-badges__badge__icon" style="width: 34px;">
            </span>
          <% } else if (tags.includes('r1-mix-match-2-for-80')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-80 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
              <img src="//www.routeone.co.uk/cdn/shop/files/2-For-80-1080x1080px_small.png?v=1711016117" class="product-card-badges__badge__icon" style="width: 34px;">
            </span>
          <% } else if (tags.includes('r1-mix-match-2-for-90')) { %>
            <span class="product-card-badges__badge product-card-badges__badge--r1-mix-match-2-for-90 product-card-badges__badge--icon-only product-card-badges__badge--transparent">
              <img src="//www.routeone.co.uk/cdn/shop/files/2-For-90-1080x1080px_small.png?v=1711016142" class="product-card-badges__badge__icon" style="width: 34px;">
            </span>
          <% } %>
        </div>
      </div>
      <div class="product-card__meta">
        <div class="product-card__title" title="<%= dataLocal.name %>"><%= dataLocal.name %></div>
        <div class="product-card__meta-row">
          <div class="product-card__price body-sm product-price">
            <% if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
              <span class="product-card__price body-sm--sale product-price__money--sale">
                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
              </span>
              <span class="money strikethrough">
                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
              </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
              <span class="product-card__price">
                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
              </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
              <span class="product-card__price">
                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
              </span>
            <% } %>
          </div>
        </div>
      </div>
    </a>
  </li>
`;


var klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">
                            <% if(false) { %>
                              <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                            <% } %>
                            <%= helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <!-- START OF CUSTOMIZATION -->
                                <button class="button button--primary button--block js-toggle-klevu-filters">
                                  Filter & sort
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.48604 15V10.2083H7.875V11.9167H15V13.3056H7.875V15H6.48604ZM0 13.3056V11.9167H5.09729V13.3056H0ZM3.70833 9.88896V8.19438H0V6.80562H3.70833V5.08333H5.09729V9.88896H3.70833ZM6.48604 8.19438V6.80562H15V8.19438H6.48604ZM9.90271 4.79167V0H11.2917V1.69438H15V3.08333H11.2917V4.79167H9.90271ZM0 3.08333V1.69438H8.51396V3.08333H0Z" fill="white"/>
                                  </svg>
                                </button>
                                <!-- END OF CUSTOMIZATION -->
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </header>
                        <%= helper.render('kuFilterTagsTemplate', scope, data, "productList") %>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                <%=helper.render('productBlock',scope,data,item) %>
                                            <% } %>
                                        <% }); %>
                                    </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer">
                          <!-- START OF CUSTOMIZATION -->
                            <%=helper.render('pagination',scope,data,"productList") %>
                          <!-- END OF CUSTOMIZATION -->
                        </footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>
                
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                
                                <% if(helper.hasResults(data,"contentList")) { %>
                                    <%=helper.render('limit',scope,data,"contentList") %>
                                    <!-- START OF CUSTOMIZATION -->
                                    <!-- END OF CUSTOMIZATION -->
                                <% } %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer">
                              <!-- START OF CUSTOMIZATION -->
                                <%=helper.render('pagination',scope,data,"contentList") %>
                              <!-- END OF CUSTOMIZATION -->
                            </footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    <% } %> 

</div>`;